<template>
    <el-card shadow="never">
        <div class="position-relative">
            <el-form :model="contato" ref="contato" label-position="top"> 
                <el-row :gutter="12">
                    <!-- Nome/Descrição -->
                    <el-col :span="16">
                        <el-form-item 
                            v-if="showName"
                            prop="nome"
                            :rules="[{ required: true, message: 'Descrição é obrigatória' }]"
                        >
                            <label>Descrição</label>
                            <el-input
                                v-model="contato.nome" 
                                placeholder="Nome, Departamento"
                                @keyup="dispatchInput"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Tipo -->
                    <el-col :span="8">
                        <el-form-item prop="tipo">
                            <label>Tipo</label>
                            <el-radio-group v-model="contato.tipo" @change="changeTipo">
                                <el-radio label="M" v-show="!is0800">Móvel</el-radio>
                                <el-radio label="F">Fixo</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>

                    <!-- Numero -->
                    <el-col :span="16">
                        <el-form-item 
                            prop="numero"
                            :rules="[{ required: true, message: 'Número é obrigatório' }]"
                        >
                            <label>Número</label>
                            <el-input
                                class="d-none"
                                v-model="contato.numero" 
                                placeholder="(99) 90000-0000"
                            />
                            <div class="el-input">
                                <the-mask 
                                    v-model="contato.numero"
                                    type="text" 
                                    class="el-input__inner" 
                                    placeholder="(99) 91234-5678"
                                    :mask="telMask" 
                                    @keyup="dispatchInput" 
                                />
                            </div>
                        </el-form-item>
                    </el-col>

                    <!-- Whatsapp -->
                    <el-col :span="8">
                        <el-form-item prop="tipo">
                            <label>Whatsapp</label>
                            <div>
                                <el-switch 
                                    v-model="contato.whatsapp" 
                                    :active-value="1"
                                    :inactive-value="0"
                                    active-text="S"
                                    inactive-text="N"
                                    @change="dispatchInput"
                                />
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="delete-contact">
                <el-button 
                    v-if="removable" 
                    type="danger" 
                    native-type="button"
                    size="small"
                    plain
                    circle
                    @click="deleteContact" 
                > 
                    <i class="fas fa-trash"></i> 
                </el-button>
            </div>
        </div>
    </el-card>
</template>

<script>
    import { Button, Form, FormItem, Input, Switch, CheckboxGroup, Checkbox, Row, Col, RadioGroup, Radio, Card  } from "element-ui"

    export default {
        props: {
            id: {
                type: Number
            },
            removable: {
                type: Boolean,
                default: true
            },
            showName: {
                type: Boolean,
                default: true
            },
            value: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        nome: "",
                        tipo: "M",
                        numero: "",
                        whatsapp: 0
                    }
                }
            },
        },
        data() {
            return {
                contato: {
                    nome: "",
                    tipo: "M",
                    numero: "",
                    whatsapp: 0
                }
            }
        },
        methods: {
            init() {

                if (typeof (this.value.nome) === 'string') {
                    this.contato.nome = this.value.nome;
                }

                if (typeof (this.value.tipo) === 'string' && (this.value.tipo === 'F' || this.value.tipo === 'M')) {
                    this.contato.tipo = this.value.tipo;
                }

                if (typeof (this.value.numero) === 'string') {
                    this.contato.numero = this.value.numero;
                }

                if (typeof (this.value.whatsapp) === 'number' || typeof (this.value.whatsapp) === 'boolean') {
                    this.contato.whatsapp = (this.value.whatsapp) ? 1 : 0;
                }

                this.dispatchInput();

            },
            changeTipo: function () {
                if (this.contato.tipo == 'F') {
                    this.contato.whatsapp = 0;
                }
                this.dispatchInput();
            },
            isValid() {
                return this.nomeIsValid && this.foneIsValid;
            },
            deleteContact() {
                this.$confirm('Deseja realmente deletar o contato?', 'Aviso', {
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                     this.$message({
                        type: 'info',
                        message: 'Contato deletado'
                    });
                    this.$emit('delete', this.id);
                }).catch(() => {
                     this.$message({
                        type: 'danger',
                        message: 'Não foi possível deletar o contato. Algo inesperado ocorreu!'
                    });
                })
            },
            dispatchInput() {

                this.$emit('input', this.contato);

            }
        },
        watch: {

            value: function (newValue, oldValue) {
                this.init();
            }
        },
        computed: {
            foneIsValid() {

                let numFone = this.contato.numero.replace(/[^0-9]/g, '');

                if (numFone.length < 10 || numFone.length > 11) {
                    return false;
                }
                return true;
            },
            nomeIsValid() {

                if (!this.showName || (this.contato.nome.length > 3 && this.showName)) {
                    return true;
                }
                return false;
            },
            is0800() {

                let tel = this.contato.numero;

                if (tel.substr(0, 4) === "0800") {
                    this.contato.tipo = "F";
                    return true;
                }

                return false;
            },
            telMask() {

                if (this.is0800) {
                    return ['#### ### ####'];
                }

                return ['(##) ####-####', '(##) #####-####'];
            }
        },
        mounted() {
            this.init();
        },
        components: {
            [Row.name]: Row,
            [Col.name]: Col,
            [Switch.name]: Switch,
            [Button.name]: Button,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [CheckboxGroup.name]: CheckboxGroup,
            [Checkbox.name]: Checkbox,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Card.name]: Card,
        }
    }
</script>

<style scoped>
    .error {
        border: solid 1px #f00;
    }

    .delete-contact {
        position: absolute;
        right: 0;
        top: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/util/Contato.vue